
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-nested-ternary */
import EventsPageContent from '@/components/client/events/EventsPageContent'
import ClientLayout from '@/components/client/layout/Index'
import { FindHeroImagesDocument } from '@/types/graphql/types'
import { initializeApollo } from 'lib/apolloClient'

const Events = () => {
  return (
    <ClientLayout>
      <EventsPageContent />
    </ClientLayout>
  )
}
export default Events

 async function _getStaticProps() {
  const apolloClient = initializeApollo()

  await Promise.all([
    apolloClient.query({
      query: FindHeroImagesDocument,
    }),
  ]).catch(() => {
    return {redirect: {
      destination: '/500'
    }}
  })

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 10,
  }
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/events/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  